

export class InvoiceStatus {
  static PENDING = "pending";
  static PAID = "paid";
  static CANCELED = "canceled";
  static REFUNDED = "refunded";
}

export class InvoiceType {
  static CREDIT = "credit";
  static DEBIT = "debit";
}

export class InvoicePaymentType {
  static CASH = "cash";
  static ONLINE = "online";
}

export const InvoiceColor = (status) => {
  switch (status) {
    case InvoiceStatus.PAID:
      return 'bg-success'
    case InvoiceStatus.REFUNDED:
      return 'bg-warning'
    case InvoiceStatus.CANCELED:
      return 'bg-danger'
    default:
      return 'bg-default'
  }
}

export const InvoiceTypeOptions = [
  {
    label: "Select Type",
    value: null
  },
  {
    label: "Credit",
    value: InvoiceType.CREDIT
  },
  {
    label: "Debit",
    value: InvoiceType.DEBIT
  }
]


export const InvoiceStatusOptions = [
  {
    label: "Select Status",
    value: null
  },
  {
    label: "Canceled",
    value: InvoiceStatus.CANCELED
  },
  {
    label: "Paid",
    value: InvoiceStatus.PAID
  },
  {
    label: "Refunded",
    value: InvoiceStatus.REFUNDED
  },
  {
    label: "Pending",
    value: InvoiceStatus.PENDING
  },
]

